// extracted by mini-css-extract-plugin
module.exports = {"container":"RelativeTimeParameterInput-module__container__1hWEk","value-input":"RelativeTimeParameterInput-module__value-input__1Qnan"};